import React from "react";
import { Link } from "react-router-dom";
import Logo from "../assets/icons/UEXCESSLOGO.png";
import "../styles/components/Footer.css";

const Footer = ({ isFixedOnHome = false }) => {
  return (
    <footer className={`footer ${isFixedOnHome ? "footer-fixed-home" : ""}`}>
      <div className="footer-left">
        <p className="footer-title">
          <a
            href="https://uexcess.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Logo} className="footer-uexcess-logo" alt="Uexcess Logo" />
            UEXCESS ERP
          </a>
        </p>
        <p className="footer-copyright">© 2024  UEXCESS ERP. Version 1.4</p>
      </div>
      <div className="footer-right">
        <Link to="/user-manual" className="footer-link footer-link-user-manual">
          User Manual
        </Link>
        <Link
          to="/shortcut-keys"
          className="footer-link footer-link-shortcut-keys"
        >
          Shortcut Keys
        </Link>
        <Link
          to="/terms-conditions"
          className="footer-link footer-link-terms-conditions"
        >
          Terms & Conditions
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
